import { Component, OnInit, Input, HostListener } from '@angular/core';

@Component({
  selector: 'app-header-one',
  templateUrl: './header-one.component.html',
  styleUrls: ['./header-one.component.scss']
})
export class HeaderOneComponent implements OnInit {
  
  @Input() class: string;
  @Input() themeLogo: string = 'assets/images/icon/logo-header-3.png'; // Default Logo
  @Input() topbar: boolean = true; // Default True
  @Input() sticky: boolean = false; // Default false
  
  public stick: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  _visibilityChangeHandler(event: any)
  {
    if (event == 'VISIBLE')
    {
      var element = document.getElementById('filter-row');
      if (!!element)
      {
        element.classList.remove('filter-btn-row-height');
      }
    }
  }

}
